var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{class:'mt-'+_vm.mt,attrs:{"cols":"12","sm":_vm.tamanho}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }